import React from 'react'
import moment from 'moment';
import styles from './Details.module.css'
import arrowUpRight from '../../../assets/images/arrow-up-right.png'


const Details = (props: any) => {

    const items = props.selectedItem && props.selectedItem.assets.length > 0 && props.selectedItem.assets.map((asset: any) => {
        return  <div key={asset.id} className={`col-4 mb-4`}>
                    <div className={`${styles.assetContainer} p-3`}>
                        <div className={styles.type}>{asset.type}</div>
                        <h5 className={styles.title}>{asset.title}</h5>
                        <p className={styles.description}>{asset.description}</p>
                        <div className={`d-flex justify-content-between`}>
                            <div className={`${styles.status} ${asset.completed ? styles.completed : (asset.started ? styles.started : '')}`}>
                                {
                                    asset.completed ?
                                        'Completed' :
                                        (
                                            asset.started ?
                                                'Started' :
                                                'Not Started'
                                        )
                                }
                            </div>
                            <a href={asset.link} target="_blank" rel="noreferrer">
                                <img src={arrowUpRight} alt="Link" width="18px" />
                            </a>
                        </div>
                    </div>
                </div>
    })

    return (
        <div className={`${styles.assetDetailsContainer} ps-4`}>
            <div className={`${styles.assetsCount} d-flex justify-content-between align-items-baseline`}>
                <div>{props.selectedType === 'completed' ? 5 : 0 } of 5 completed</div>
                
                {
                    props.selectedType !== 'completed' &&
                    <div className={`${styles.dueDate} ${moment(props.selectedItem.dueDate).fromNow().includes('ago') && styles.expired}`}>
                        Due {
                            moment(props.selectedItem.dueDate).fromNow()
                        }
                    </div>
                }
            </div>
            <p className={styles.detailsDescription}>Here are the list of links that are recommended for your improvement in this area</p>
            <div className={`row`}>
                {items}
            </div>
        </div>
    )
}

export default Details
